import { useId } from "react";
import logoLightUrl from "@/assets/brand/logo-balanced.png";
import logoDarkUrl from "@/assets/brand/logo-balanced-dark.png";
import { useTheme } from "@/components/theme-provider";

const LOGO_WIDTH = 1947;
const LOGO_HEIGHT = 808;
// Add about 4px of space at the shell's 36px display height.
const WORDMARK_OFFSET = 96;

export function BrandLogo({ className }: { className?: string }) {
  const id = useId();
  const { resolvedTheme } = useTheme();
  const logoUrl = resolvedTheme === "dark" ? logoDarkUrl : logoLightUrl;

  return (
    <svg
      aria-label="Tickbird"
      className={className}
      height={LOGO_HEIGHT}
      role="img"
      viewBox={`0 0 ${LOGO_WIDTH + WORDMARK_OFFSET} ${LOGO_HEIGHT}`}
      width={LOGO_WIDTH + WORDMARK_OFFSET}
    >
      <title>Tickbird</title>
      <defs>
        {/* Isolate the wordmark without clipping the beak above it. */}
        <clipPath id={`${id}-symbol`}>
          <path d="M0 0H1947V280H640V580H1947V808H0Z" />
        </clipPath>
        <clipPath id={`${id}-wordmark`}>
          <rect height="300" width="1307" x="640" y="280" />
        </clipPath>
      </defs>
      <image clipPath={`url(#${id}-symbol)`} height={LOGO_HEIGHT} href={logoUrl} width={LOGO_WIDTH} />
      <g transform={`translate(${WORDMARK_OFFSET} 0)`}>
        <image clipPath={`url(#${id}-wordmark)`} height={LOGO_HEIGHT} href={logoUrl} width={LOGO_WIDTH} />
      </g>
    </svg>
  );
}
